import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { SlideOutPanel } from "SlideOutPanel";
import styles from "./SlideOutMenuPanel.module.scss";

const SlideOutMenuPanel = ({
	id,
	classNames,
	labels,
	isOpen,
	handleClose,
	focusOnShouldIgnore,
	children,
}) => (
	<SlideOutPanel
		id={id}
		classNames={{
			menu: cx(styles.sideMenu, classNames.menu),
			titleContainer: styles.titleContainer,
		}}
		labels={labels}
		isOpen={isOpen}
		handleClose={handleClose}
		focusOnShouldIgnore={focusOnShouldIgnore}>
		{children}
	</SlideOutPanel>
);

SlideOutMenuPanel.propTypes = {
	id: PropTypes.string.isRequired,
	classNames: PropTypes.shape({
		menu: PropTypes.string,
	}),
	labels: PropTypes.shape({
		title: PropTypes.string,
		closeMenu: PropTypes.string,
	}),
	isOpen: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
	focusOnShouldIgnore: PropTypes.func,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
SlideOutMenuPanel.defaultProps = {
	classNames: {},
	labels: {
		title: "Menu",
		closeMenu: "Close menu",
	},
	focusOnShouldIgnore: () => true,
};

export default SlideOutMenuPanel;
export { SlideOutMenuPanel };
